import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Cross, ArrowLeft } from "lucide-react";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { staffLogin } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await staffLogin(password); navigate("/admin"); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-b from-primary/5 to-background px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground mb-6 hover:text-foreground"><ArrowLeft className="h-4 w-4" /> Accueil</Link>
        <Card className="rounded-2xl p-8">
          <div className="flex items-center gap-2.5 mb-6">
            <div className="h-10 w-10 rounded-xl bg-primary grid place-items-center text-primary-foreground"><Cross className="h-5 w-5" /></div>
            <div><div className="font-heading font-bold">Espace officine</div><div className="text-xs text-muted-foreground">Pharmacie des Écoles</div></div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5"><Label htmlFor="pw">Mot de passe</Label>
              <Input id="pw" type="password" data-testid="login-password" autoFocus value={password} onChange={(e) => setPassword(e.target.value)} required className="h-12 rounded-xl" /></div>
            {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading || !password} data-testid="login-submit" className="w-full h-12 rounded-xl font-semibold">{loading ? "Connexion…" : "Se connecter"}</Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
